<template>
  <div class="widget-card-footer">
    <div class="widget-card-buttons">
      <template v-if="copyLinkButton && copyLinkButton.links">
        <div
            class="copy-link-box"
            :class="{'multi': copyLinkButton.links.length > 1, 'active': linkListIsActive}"
        >
          <div v-if="copyLinkButton.links.length > 1" v-show="!toastIsActive" class="links">
            <ul>
              <li
                  v-for="(link, index) in getSortedLinks()"
                  :key="index"
                  @click="handleLinkListItem(link.value)"
              >
                {{link.name}}
              </li>
            </ul>
          </div>
          <div v-show="toastIsActive" class="toast">
            <i class="fas fa-check-circle"></i>
            Link copied
          </div>
          <button
                  @click="handleCopyBtnClick()"
                  class="widget-card-button copy-link"
                  ref="copyButton"
          >
            <span>COPY LINK</span>
            <svg v-if="copyLinkButton.links.length > 1"
                 width="14" height="9" viewBox="0 0 14 9" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M11.9587 1.19212L6.99587 6.43922L2.033 1.19149C1.79638 0.94138
                    1.41363 0.94138 1.17701 1.19149C0.940996 1.44159 0.940996 1.8468 1.17701
                    2.09691L6.5676 7.79675C6.80362 8.04685 7.18697 8.04685 7.42299 7.79675L12.8136
                    2.09696C13.0496 1.84685 13.0496 1.44101 12.8136 1.19091C12.5782 0.942012
                    12.1948 0.942012 11.9587 1.19212Z"
                    fill="#68BA62" stroke="#68BA62"
              />
            </svg>
          </button>
        </div>
      </template>

      <template v-if="to && to.name">
        <b-button
            v-if="actionButton && actionButton.text"
            tag="router-link"
            :to="to"
            class="widget-card-button filled manage-page"
            :class="actionButtonClass"
        >
          {{actionButton.text}}
        </b-button>
      </template>
      <template v-else>
        <button
            v-if="actionButton && actionButton.text"
            class="widget-card-button filled manage-page"
            :to="{ name: 'training-and-faqs' }"
            :class="actionButtonClass"
        >
          {{actionButton.text}}
        </button>
      </template>
    </div>
  </div>
</template>

<script>
import clipboardMixin from '@/mixins/clipboard';

export default {
  name: 'WidgetCardFooter',
  mixins: [clipboardMixin],
  data() {
    return {
      toastIsActive: false,
      toastTimeout: null,
      linkListIsActive: false,
    };
  },
  props: {
    copyLinkButton: {
      links: {
        type: Array,
        default: null,
      },
    },
    actionButton: {
      text: {
        type: String,
        default: null,
      },
    },
    to: {
      name: {
        type: String,
        default: null,
      },
    },
  },
  mounted() {
    if (this.copyLinkButton && this.copyLinkButton.links.length > 1) {
      this.$root.$on('app-click', this.handleAppClick);
    }
  },
  beforeDestroy() {
    this.$root.$off('app-click', this.handleAppClick);
  },
  deactivated() {
    this.$root.$off('app-click', this.handleAppClick);
  },
  computed: {
    actionButtonClass() {
      return this.actionButton.text.length >= 15 ? 'long' : 'short';
    },
  },
  methods: {
    getSortedLinks() {
      return [...this.copyLinkButton.links].sort((a, b) => {
        const aName = a.name.toLowerCase();
        const bName = b.name.toLowerCase();
        if (aName > bName) {
          return 1;
        }
        if (aName < bName) {
          return -1;
        }
        return 0;
      });
    },
    handleAppClick(event) {
      if (this.$refs.copyButton && !this.$refs.copyButton.contains(event.target)) {
        this.linkListIsActive = false;
      }
    },
    handleCopyBtnClick() {
      if (this.copyLinkButton.links.length === 1) {
        const copyText = this.copyLinkButton.links[0].value;
        this.copyToClipboard(copyText);
      }

      if (this.copyLinkButton.links.length > 1) {
        this.linkListIsActive = !this.linkListIsActive;
      }
    },
    handleLinkListItem(copyText) {
      this.copyToClipboard(copyText);
      this.linkListIsActive = false;
    },
    copyToClipboard(text) {
      if (text) {
        const copiedSuccessfully = this.copyTextToClipboard(text);
        if (copiedSuccessfully) {
          this.toastIsActive = true;
          if (this.toastTimeout) {
            clearTimeout(this.toastTimeout);
          }
          this.toastTimeout = setTimeout(() => { this.toastIsActive = false; }, 1000);
        } else {
          this.$buefy.toast.open({
            message: 'The clipboard is not available',
            type: 'is-danger',
            duration: 5000,
          });
        }
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.widget-card-footer {
  margin-top: auto;
  position: relative;
}
.widget-card-footer .widget-card-buttons {
  display: flex;
  margin: -5px;
}

.widget-card-button {
  margin: 5px;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  border: 2px #68BA62 solid;
  cursor: pointer;
  color: #68BA62;
  height: 48px;
  background-color: #FFFFFF;
  border-radius: 3px;
  padding: 0;
  @media (max-width 768px) {
    font-size: 14px;
  }
  @media (max-width 600px) {
    font-size: 16px;
  }
  &.copy-link {
    white-space: nowrap;
    width: 120px;
    @media (max-width 1170px) {
      width: 98px;
    }
    @media (max-width 600px) {
      width: 120px;
    }
    @media (max-width 480px) {
      width: 98px;
    }
  }
  &.long {
    width: 262px;
    @media (max-width 1170px) {
      width: 250px;
    }
    @media (max-width 768px) {
      width: 230px;
    }
    @media (max-width 600px) {
      width: 262px;
    }
    @media (max-width 480px) {
      width: 250px;
    }
  }
  &.short {
    width: 180px;
    @media (max-width 1170px) {
      width: 144px;
    }
    @media (max-width 747px) {
      width: 124px;
    }
    @media (max-width 600px) {
      width: 180px;
    }
    @media (max-width 480px) {
      width: 144px;
    }
  }
  &:hover {
    color: #17B548;
    border-color: #17B548;
  }
  &.filled {
    background-color: #68BA62;
    color: #FFFFFF;
    &:hover {
      color: #FFFFFF;
      background-color: #17B548;
    }
  }
}
.copy-link-box {
  .links {
    display: none;
  }
  .toast {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, calc(-100% - 6px));
    width: 170px;
    color: #68BA62;
    font-size: 18px;
    font-weight: 500;
    line-height: 21.6px;
    padding 12px 21px;
    background-color: #DCF4E4;
  }
  &.multi {
    &.active {
      .links {
        display: block;
        position: absolute;
        width: 340px;
        max-width: 100%;
        top: 0;
        left: 0;
        transform: translate(0, -100%);
        padding-bottom: 4px;
        ul {
          box-shadow: 0 1px 8px 0 #525F661A;
          border: 1px solid #DDDFE2;
          max-height: 250px;
          overflow-y: scroll;
          overflow-x hidden;
          & li {
            background-color: #FFFFFF;
            padding: 8px 16px;
            cursor: pointer;
            &:hover {
              background-color: #d2ebd0;
            }
          }
        }
      }
    }
    & .copy-link {
      position: relative;
      width: 132px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 15px;
      & svg {
        width: 11.99px;
        min-width: 11.99px;
        transform: translate(0, -1px);
      }
      @media (max-width 1170px) {
        width: 98px;
        padding: 0 4px;
      }
      @media (max-width 768px) {
        padding: 0 6px;
      }
      @media (max-width 600px) {
        width: 120px;
        padding: 0 9px;
      }
      @media (max-width 480px) {
        width: 98px;
        padding: 0 2px;
      }
      &:hover {
        &:after {
          border-bottom: 2px solid #17B548;
        }
      }
    }
  }
}
</style>
